import { OWN_PROFILE_SETTINGS_PATH } from '@/services/userProfile/constants';
import apiClient from '@/services/api';

class UserProfile {
  /**
   * Constructor that receives the user object
   * @param {Object} user - The user object containing profile information
   */
  constructor(user) {
    // Set the profile directly from the user passed in constructor
    this.profile = user || {};
  }

  /**
   * Updates all user settings
   * @param putPayload
   * @returns {Promise<void>}
   */
  putUserSettings = async (putPayload) => {
    try {
      const response = await apiClient.put(
        OWN_PROFILE_SETTINGS_PATH,
        putPayload
      );
      this.commitSettings(response.data);
      return response.data;
    } catch (error) {
      console.error('Error updating user settings:', error);
      throw error;
    }
  };

  /**
   * Patches single user settings
   * @param patchPayload
   * @returns {Promise<void>}
   */
  patchUserSetting = async (patchPayload) => {
    try {
      const { data } = await apiClient.patch(
        OWN_PROFILE_SETTINGS_PATH,
        patchPayload
      );
      this.commitSettings(data);
      return data;
    } catch (error) {
      console.error('Error patching user setting:', error);
      throw error;
    }
  };

  /**
   * Sets up base profile data
   * @param responseBody
   */
  commit(responseBody) {
    this.profile = responseBody;
  }

  /**
   * Updates profile settings
   * @param responseBody
   */
  commitSettings(responseBody) {
    this.profile.settings = responseBody.userSettings;
  }

  get email() {
    return this.profile.email;
  }

  get firstname() {
    return this.profile.firstName;
  }

  get initials() {
    let firstInitial = '';
    let secondInitial = '';
    if (!this.firstname) {
      return '';
    }
    firstInitial = this.firstname.substr(0, 1).toUpperCase();
    secondInitial = this.lastname.substr(0, 1).toUpperCase();
    return `${firstInitial}${secondInitial}`;
  }

  get lastname() {
    return this.profile.lastName;
  }

  get permissions() {
    return this.profile.permissions;
  }

  // Removed the redundant profile getter

  get settings() {
    return this.profile.settings;
  }

  get actions() {
    return this.profile.actions;
  }

  get tenants() {
    return this.profile.tenants;
  }
}

export default UserProfile;
